export default class SukuContainer extends HTMLElement {
  constructor() {
    super()

    this.model = null
    this.className = 'flex w-screen min-h-[calc(100vh-110px)] mobile:flex-wrap'
    
    this.selections = "[]"

    this.addEventListener('suku-update', evt => {
      const option = evt.detail.option

      const update = JSON.decode(this.selections).find(selection => {
        return selection.id === option.id
      })

      if (update) {
        this.update('modify', option)
      } else {
        this.update('add', option)
      }
    })

    this.addEventListener('suku-init', evt => {
      this.model = evt.detail.model
    })

    this.update.bind(this)
  }

  update(type, option) {
    let selections = JSON.decode(this.selections)

    switch (type) {
      case 'add' :
        selections.push(option)
      break
      case 'modify' :
        const modified = selections.reduce((arr, current) => {
          // does item exist ? if so swap in new option otherwise keep existing / current
          const item = current.category !== option.category && current.size !== option.size ? current : option

          arr.push(item)

          return arr
        }, [])
        
        selections = modified
      break
    }

    // update selections
    this.selections = JSON.decode(modified)
  }
}

customElements.define('suku-container', SukuContainer)
